<template>
    <div>
        <div v-for="babyNum in range(response['BIRTH_NUMBER'])" :key="babyNum" class="mb-4">
            <div v-if="response['BIRTH_NUMBER'] > 1" class="mb-2 fw-bold text-decoration-underline">
                {{ props.question.header[participant.language] }}{{ babyNum }}
            </div>
            <div class="mb-2">{{ props.question.text[participant.language] }}</div>
            <div v-for="answer in props.question.answers" :key="answer.value" class="ms-4 mb-4 form-check">
                <input 
                    class="form-check-input" 
                    type="radio" 
                    :name="props.question.variable + '_' + babyNum"
                    :id="props.question.variable + '_' + babyNum + '_' + answer.value"
                    :value="answer.value"
                    :checked="babyNumResponse(babyNum, response) == answer.value"
                    @click="event => updateResponseBabies(babyNum, response, event)"
                >
                <label 
                    class="form-check-label" 
                    :for="props.question.variable + '_' + babyNum + '_' + answer.value"
                >
                    {{ answer.label[participant.language] }}
                </label>
            </div>
        </div>
    </div>
</template>


<script setup>
    import { storeToRefs } from 'pinia'
    import { useSurveysStore } from '../../../stores/surveys'

    const { saveResponse, saveResponseBabies } = useSurveysStore()
    const { participant, response } = storeToRefs(useSurveysStore())
    const props = defineProps(['question'])

    function range(n) {
        return [...Array(n).keys()].map(x => x + 1);
    }

    function babyNumResponse(babyNum, response) {
        let jsonResponse

        if (response[props.question.variable] && typeof response[props.question.variable] === 'string') {
            try {
                jsonResponse = JSON.parse(response[props.question.variable])
            } catch (e) {
                console.dir(e)
                return 0
            }
        } else if (typeof response[props.question.variable] === 'object' && response[props.question.variable] !== null) {
            jsonResponse = response[props.question.variable]
        } else {
            return 0
        }

        return jsonResponse && jsonResponse['baby' + babyNum] ? jsonResponse['baby' + babyNum] : 0
    }

    function updateResponseBabies(babyNum, response, event) {

        const origResponse = response[props.question.variable]

        let jsonResponse
        if (typeof origResponse === 'string') {
            try {
                jsonResponse = JSON.parse(origResponse)
            } catch (e) {
                console.dir(e)
                jsonResponse = {}
            }
        } else if (typeof origResponse === 'object' && origResponse !== null) {
            jsonResponse = origResponse
        } else {
            jsonResponse = {}
        }

        const value = parseInt(event.target.value)
        jsonResponse['baby' + babyNum] = isNaN(value) ? event.target.value : value

        let origString = null
        if (origResponse !== null) {
            if (typeof origResponse === 'string') {
                origString = origResponse
            } else {
                origString = JSON.stringify(origResponse)
            }
        }
        let newString = JSON.stringify(jsonResponse)

        origString = origString ? origString.replace(/\s+/g, '') : ''
        newString = newString.replace(/\s+/g, '')

        console.log(origString +' == '+ newString)
        if (origString && origString != newString) {
            console.log('not the same :-(')
            // q39, 39a
            response['BABY_NICU'] = null
            response['BABY_NICU_LENGTH'] = null
            // q46, 47, 48
            response['FEEDING_INTENT_POST'] = null
            response['FEEDING_SUCCESS'] = null
            response['FEEDING_SUPPORT'] = null
            // q49a-n
            response['BSES_ENOUGHMILK'] = null
            response['BSES_COPING'] = null
            response['BSES_FORMULA'] = null
            response['BSES_LATCH'] = null
            response['BSES_MANAGE'] = null
            response['BSES_BABYCRYING'] = null
            response['BSES_INTENTION'] = null
            response['BSES_FAMILY'] = null
            response['BSES_SATISFACTION'] = null
            response['BSES_TIMECONSUMING'] = null
            response['BSES_SWITCH'] = null
            response['BSES_BFEVERYFEEDING'] = null
            response['BSES_BABYDEMANDS'] = null
            response['BSES_BABYFINISHED'] = null

            saveResponse()
        }

        saveResponseBabies(props.question.variable, jsonResponse)
    }



</script>